/**
 * @Author: leibin
 * @Date: 2022-01-18 20:59:16
 * @LastEditors: leibin@baijia.com
 * @LastEditTime: 2022-01-18 20:59:16
 * @FilePath: /pcweb-station/constants/signUpPathSource.js
 * @Description: 创建订单接口需要带的source来源参数， 参数来自于淘金, https: //wiki.baijia.com/pages/viewpage.action?pageId=137351163
 */

import qs from 'qs';
import Cookies from 'js-cookie';
import Vue from 'vue';
import getUuid from '@base/util/uuid';
import {EVENT_ID_CREATE_LEADSID} from '@base/constants/haboEvent';
import {TAOJING_SOURCE} from '@base/constants/homepage';

// 课程类型:联班课
const CLAZZ_SET_COURSE_ID = 23;
// 课程类型:专题课
const SPECIAL_COURSE_ID = 5;
// 课程类型:系列课
const SERIES_COURSE_ID = 4;
// 课程类型:公开课
const OPEN_COURCE_ID = 1;
// 课程类型:体验课
const EXPERIENCE_COURCE_ID = 6;

let p_client;

try {
    p_client = window.__NUXT__?.state?.p_client || 18;
}
catch (error) {
    p_client = 18;
}

// 对象键名代表操作页面路径，比如 选课中心-课程详情页 CATEGORY_COURSE
export const SIGN_UP_PATH = {
    // 通过公开课卡片一键报名下单时，上报该 source
    SIGN_UP_PATH_CATEGORY: p_client === 8 ? 'tj179985232846391296z' : 'tj165150107625330688z',
    // 选课中心页面卡片进入详情页后，在下单时上报 source
    SIGN_UP_PATH_CATEGORY_COURSE: p_client === 8 ? 'tj179985072082913281z' : 'tj165150107697683456z',
    // 默认兜底source
    DEFAULT_SOURCE: 'tj173304329617277952z'
};

// 区分正价课和引流课
export const COURSE_TYPE_ID_COLLECT = {
    // 系列课、专题课、联报课  （正价课）
    SYSTEM_COURSE_ARRAY: [SERIES_COURSE_ID, SPECIAL_COURSE_ID, CLAZZ_SET_COURSE_ID],
    // 体验课 公开课  （引流课）
    WELFARES_AND_OPEN_COURSE_ARRAY: [OPEN_COURCE_ID, EXPERIENCE_COURCE_ID]
};


/**
 *
 * H5点击免费报名，哈勃上报business_leads_id
 */
export const createOrderHaboEvent = ({source, businessLeadsId, skuId}) => {
    Vue.prototype.$habo?.haboClickReport(EVENT_ID_CREATE_LEADSID, {
        sourceId: source,
        businessLeadsId,
        skuId,
    });
};

/**
 *
 * 生成BusinessLeadsId
 */
export const getBusinessLeadsId = ({source, skuId}) => {
    try {
        const cookieName = `source_leads_${source}_${skuId}`;
        const sourceData = localStorage.getItem(cookieName);
        let {businessLeadsId = ''} = JSON.parse(sourceData) || {};
        let hasCookie = true;
        if (!businessLeadsId) {
            const uuid = getUuid();
            const gid = Cookies.get('GID') || uuid;
            const date = new Date().valueOf();
            businessLeadsId = skuId ? `${source}_${gid}_${date}_${skuId}` : `${source}_${gid}_${date}`;
            localStorage.setItem(cookieName, JSON.stringify({
                businessLeadsId,
                createTime: date
            }));
            hasCookie = false;
        }
        return {
            businessLeadsId,
            hasCookie
        };
    }
    catch (error) {
        console.error(error);
        return {
            businessLeadsId: '',
            hasCookie: true
        };
    }
};


/**
 * 获取用于记录访问路径的标记
 *
 * @return <string> 访问路径的标记
 */
export function getSignUpPathTag() {
    const {pathname = ''} = window.location;
    const coursePageReg = /learn\/\d+/;
    const productPageReg = /product\/\d+/;
    const sublistPageReg = /sublist\/\d+/;
    let signUpPathTag = '';
    // 当前是课程详情页,前一个页面是课程中心
    if (pathname.match(coursePageReg) || pathname.match(sublistPageReg) || pathname.match(productPageReg)) {
        const urlQuery = location.search.slice(1);
        const query = qs.parse(urlQuery);
        // 兼容淘金自动拼接source，在课程详情页，有source用source，否则用原来逻辑
        signUpPathTag = query.source || query.signUpPathTag || '';
    }
    // 当前页面是首页
    else if (pathname === '/') {
        signUpPathTag = TAOJING_SOURCE.OPENCOURSE_ORDER;
    }
    // 当前页面是课程中心
    else if (pathname.indexOf('/category') !== -1) {
        signUpPathTag = SIGN_UP_PATH.SIGN_UP_PATH_CATEGORY;
    }
    // 其它课程链接
    else {
        const urlQuery = location.search.slice(1);
        const query = qs.parse(urlQuery);
        signUpPathTag = query.source || query.signUpPathTag || '';
    }

    return signUpPathTag || SIGN_UP_PATH.DEFAULT_SOURCE;
}

/**
 * 往参数中新增 orderTag 用于统计下单的来源信息
 *
 * @param {Object} params 下单参数
 */
export function addOrderTagToParams(params = {}, source = '') {
    // 从上面代码逻辑来看，params.orderTagStr 可能是数组转成的json串，或者是空
    const signUpPathTag = source || getSignUpPathTag();
    if (signUpPathTag) {
        const {businessLeadsId, hasCookie} = getBusinessLeadsId({source: signUpPathTag, skuId: params.productId});
        let businessLeadsIdValue = businessLeadsId;
        const sourceLeads = Vue.prototype.$sourceLeads;

        if (businessLeadsId && sourceLeads) {
            // 若真leads和伪leads同时存在，通过&&隔开
            // wiki：https://wiki.baijia.com/pages/viewpage.action?pageId=182151754
            businessLeadsIdValue += `&&${sourceLeads}`;
        }
        if (!hasCookie) {
            createOrderHaboEvent({
                source: signUpPathTag,
                businessLeadsId,
                skuId: params?.productId,
            });
        }
        const orderTag = businessLeadsId
            ? [
                {
                    orderTagType: 'source',
                    orderTagValue: signUpPathTag,
                },
                {
                    orderTagType: 'businessLeadsId',
                    orderTagValue: businessLeadsIdValue,
                },
            ]
            : [
                {
                    orderTagType: 'source',
                    orderTagValue: signUpPathTag,
                }
            ];
        params.orderTagStr = params.orderTagStr || '';
        if (params.orderTagStr) {
            try {
                const oldOrderTagStr = JSON.parse(params.orderTagStr);
                oldOrderTagStr.push(...orderTag);
                params.orderTagStr = JSON.stringify(oldOrderTagStr);
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            params.orderTagStr = JSON.stringify(orderTag);
        }
    }
}
